// store/reducers/notificationReducer.js
import actions from "./action";

const initialState = {
  shouldReload: false, // Simple flag to trigger reload
};

export default function notificationReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        shouldReload: action.payload,
      };
    default:
      return state;
  }
}
